module.exports = __webpack_public_path__ + "img/image01@2x.bf635141.webp";